<mat-toolbar class="mat-elevation-z4" color="primary" *ngIf="user">
  <mat-toolbar-row>
    <a *ngIf="!user.isTicketOnly()" href="/home" routerLink="/home" class="brand-link">Studio {{ user.studio?.nome }}</a>
    <a *ngIf="user.isTicketOnly()" routerLink="/tickets" class="brand-link">Assistenza Tickets</a>

    <div class="ml-auto">
      <button
        *ngIf="user.hasAnyRole(['amministratore'])"
        class="admin-btn"
        mat-button
        href="/admin/users"
        [routerLink]="['/admin/users']"
        matTooltip="Pannello Admin"
        aria-label="Pannello Admin"
      >
        <mat-icon>admin_panel_settings</mat-icon>
      </button>


      <button
        *ngIf="!user.isTicketOnly()"
        mat-icon-button
        class="annunci-btn"
        (click)="toggleAnnunci()"
        matTooltip="Annunci"
        aria-label="Annunci"
        [matBadge]="unreadCount"
        [matBadgeHidden]="unreadCount === 0"
        matBadgeColor="warn"
        matBadgeOverlap="true"
        matBadgeSize="small"
        matBadgePosition="above after"
      >
        <mat-icon>notifications</mat-icon>
      </button>

      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon class="user-icon">person</mat-icon>
        <span class="user-name">{{ user.humanIdentifier }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button *ngIf="!user.isTicketOnly()" href="/user" routerLink="user" mat-menu-item>
          <span>Pagina Utente</span>
          <span>
            <mat-icon>person</mat-icon>
          </span>
        </button>

        <button
          mat-menu-item
          *ngIf="user?.linked_users?.length && !user.isTicketOnly()"
          [matMenuTriggerFor]="linkedAccountsMenu"
        >
          <span>Cambia Account</span>
        </button>

        <button (click)="emitLogoutEvent()" mat-menu-item>
          <span>Logout</span>
          <span>
            <mat-icon>exit_to_app</mat-icon>
          </span>
        </button>
      </mat-menu>

      <!-- Submenu per account collegati -->
      <mat-menu #linkedAccountsMenu="matMenu">
        <button
          mat-menu-item
          class="linked-account-item"
          *ngFor="let linkedUser of user?.linked_users"
          (click)="switchAccount(linkedUser)"
          [disabled]="switchingAccount"
        >
          <span>{{ linkedUser.nome }} {{ linkedUser.cognome }}</span>
          <small *ngIf="linkedUser.studio" class="studio-label"
            >({{ linkedUser.studio.nome }})</small
          >
        </button>
      </mat-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<ng-container *ngIf="user">
  <div
    class="annunci-backdrop"
    *ngIf="annunciOpen"
    (click)="closeAnnunci()"
  ></div>
  <aside class="annunci-sidebar mat-elevation-z8" [class.open]="annunciOpen">
    <div class="annunci-header">
      <h3>Comunicazioni di Servizio</h3>
      <button
        mat-icon-button
        (click)="closeAnnunci()"
        aria-label="Chiudi annunci"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="annunci-content" *ngIf="annunciLoading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    <div class="annunci-content" *ngIf="!annunciLoading">
      <ng-container *ngIf="annunci?.length; else noAnnunci">
        <div class="annuncio-item" *ngFor="let annuncio of annunci">
          <div class="annuncio-title">{{ annuncio.titolo }}</div>
          <div class="annuncio-date">
            {{ annuncio.created_at?.format("DD/MM/YYYY HH:mm") }}
          </div>
          <div class="annuncio-body">
            {{ annuncio.contenuto }}
          </div>
          <div class="annuncio-attachments" *ngIf="annuncio.allegati?.length">
            <div class="attachment" *ngFor="let allegato of annuncio.allegati">
              <button mat-button (click)="openAllegato(allegato)" type="button">
                <mat-icon>{{
                  allegato.isVideo ? "play_circle" : "attach_file"
                }}</mat-icon>
                <span>{{ allegato.nome_originale }}</span>
                <span *ngIf="allegato.isVideo" class="attachment-tag"
                  >Video</span
                >
              </button>
            </div>
          </div>
          <div class="annuncio-footer" *ngIf="!annuncio.isRead">
            <mat-checkbox
              color="primary"
              [checked]="annuncio.isRead"
              [disabled]="annuncio.isRead || markingAsRead[annuncio.id]"
              (change)="onSegnaComeLetto(annuncio, $event)"
            >
              Segna come letto
            </mat-checkbox>
          </div>
        </div>
      </ng-container>
      <ng-template #noAnnunci>
        <p class="annunci-empty">Nessun annuncio disponibile.</p>
      </ng-template>
    </div>
  </aside>
</ng-container>
